import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sdParse',
  standalone: true
})
export class SdParsePipe implements PipeTransform {
  transform(value: string): any[] {
    return JSON.parse(value);
  }
}
